(() => {
  function initEmbroidery(root) {
    if (!root || root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';

    const blockId = root.dataset.embroideryBlock;

    const charactersMaxTemplate =
      root.dataset.charactersMax || '__COUNT__ characters max.';

    const productLabel =
      root.dataset.productLabel || 'Product';

    const configuredLabel =
      root.dataset.configuredLabel || 'Configured';

    const toConfigureLabel =
      root.dataset.toConfigureLabel || 'To configure';

    const toEnterLabel =
      root.dataset.toEnterLabel || 'To enter';

    const toChooseLabel =
      root.dataset.toChooseLabel || 'To choose';

    const selectSizeLabel =
      root.dataset.selectSizeLabel ||
      'Please select a size before continuing.';

    const addingToCartLabel =
      root.dataset.addingToCartLabel || 'Adding to cart…';

    /*
     * =====================================================
     * ROOT ELEMENTS
     * =====================================================
     */

    const openButton = root.querySelector(
      '[data-embroidery-open]'
    );

    const overlay = root.querySelector(
      '[data-embroidery-overlay]'
    );

    if (!overlay) {
      return;
    }

    /*
     * =====================================================
     * CONFIGURATION
     * =====================================================
     */

    const dataElement = document.getElementById(
      `embroidery-data-${blockId}`
    );

    if (!dataElement) {
      console.warn(
        `Embroidery: configuration not found for block ${blockId}`
      );

      return;
    }

    let config;

    try {
      config = JSON.parse(
        dataElement.textContent
      );
    } catch (error) {
      console.error(
        'Embroidery: invalid configuration JSON.',
        error
      );

      return;
    }

    /*
     * =====================================================
     * ESCAPE ATELIER STACKING CONTEXT
     * =====================================================
     */

    document.body.appendChild(
      overlay
    );

    /*
     * =====================================================
     * ELEMENTS
     * =====================================================
     */

    const closeButton = overlay.querySelector(
      '[data-embroidery-close]'
    );

    const textPanel = overlay.querySelector(
      '[data-text-panel]'
    );

    const symbolPanel = overlay.querySelector(
      '[data-symbol-panel]'
    );

    const submitButton = overlay.querySelector(
      '[data-embroidery-submit]'
    );

    const errorElement = overlay.querySelector(
      '[data-embroidery-error]'
    );

    const textInput = overlay.querySelector(
      '[data-embroidery-text]'
    );

    /*
    * Pillow pair (Taies) and hand towel pair (Paires)
    * text fields.
    */

    const textInputLeft =
      overlay.querySelector('[data-embroidery-text-left]') ||
      overlay.querySelector('[data-embroidery-text-hand-towel="1"]');

    const textInputRight =
      overlay.querySelector('[data-embroidery-text-right]') ||
      overlay.querySelector('[data-embroidery-text-hand-towel="2"]');

const textInputTowel1 = overlay.querySelector(
  '[data-embroidery-text-towel-1]'
);

const textInputTowel2 = overlay.querySelector(
  '[data-embroidery-text-towel-2]'
);

const textInputTowel3 = overlay.querySelector(
  '[data-embroidery-text-towel-3]'
);

const textInputTowel4 = overlay.querySelector(
  '[data-embroidery-text-towel-4]'
);

/*
 * 2-serviettes pack text fields.
 */

const textInputTwoTowels1 = overlay.querySelector(
  '[data-embroidery-text-two-towels-1]'
);

const textInputTwoTowels2 = overlay.querySelector(
  '[data-embroidery-text-two-towels-2]'
);

const characterCountTwoTowels1 = overlay.querySelector(
  '[data-character-count-two-towels-1]'
);

const characterCountTwoTowels2 = overlay.querySelector(
  '[data-character-count-two-towels-2]'
);

const characterMaxTwoTowels1 = overlay.querySelector(
  '[data-character-max-two-towels-1]'
);

const characterMaxTwoTowels2 = overlay.querySelector(
  '[data-character-max-two-towels-2]'
);

const heartButtonTwoTowels1 = overlay.querySelector(
  '[data-insert-heart-two-towels-1]'
);

const heartButtonTwoTowels2 = overlay.querySelector(
  '[data-insert-heart-two-towels-2]'
);

const characterCountLeft =
  overlay.querySelector('[data-character-count-left]') ||
  overlay.querySelector('[data-character-count-hand-towel="1"]');

const characterCountRight =
  overlay.querySelector('[data-character-count-right]') ||
  overlay.querySelector('[data-character-count-hand-towel="2"]');

const characterCountTowel1 = overlay.querySelector(
  '[data-character-count-towel-1]'
);

const characterCountTowel2 = overlay.querySelector(
  '[data-character-count-towel-2]'
);

const characterCountTowel3 = overlay.querySelector(
  '[data-character-count-towel-3]'
);

const characterCountTowel4 = overlay.querySelector(
  '[data-character-count-towel-4]'
);

const characterMaxLeft =
  overlay.querySelector('[data-character-max-left]') ||
  overlay.querySelector('[data-character-max-hand-towel="1"]');

const characterMaxRight =
  overlay.querySelector('[data-character-max-right]') ||
  overlay.querySelector('[data-character-max-hand-towel="2"]');

const characterMaxTowel1 = overlay.querySelector(
  '[data-character-max-towel-1]'
);

const characterMaxTowel2 = overlay.querySelector(
  '[data-character-max-towel-2]'
);

const characterMaxTowel3 = overlay.querySelector(
  '[data-character-max-towel-3]'
);

const characterMaxTowel4 = overlay.querySelector(
  '[data-character-max-towel-4]'
);

const heartButtonLeft =
  overlay.querySelector('[data-insert-heart-left]') ||
  overlay.querySelector('[data-insert-heart-hand-towel="1"]');

const heartButtonRight =
  overlay.querySelector('[data-insert-heart-right]') ||
  overlay.querySelector('[data-insert-heart-hand-towel="2"]');

const heartButtonTowel1 = overlay.querySelector(
  '[data-insert-heart-towel-1]'
);

const heartButtonTowel2 = overlay.querySelector(
  '[data-insert-heart-towel-2]'
);

const heartButtonTowel3 = overlay.querySelector(
  '[data-insert-heart-towel-3]'
);

const heartButtonTowel4 = overlay.querySelector(
  '[data-insert-heart-towel-4]'
);

    const productMaxCharacters = textInput
      ? Number(textInput.dataset.maxCharacters || 20)
      : 20;

    const characterCount = overlay.querySelector(
      '[data-character-count]'
    );

    const characterMax = overlay.querySelector(
  '[data-character-max]'
);

    const heartButton = overlay.querySelector(
      '[data-insert-heart]'
    );

    const colourSelect = overlay.querySelector(
      '[data-embroidery-colour]'
    );

    const colourPreview = overlay.querySelector(
      '[data-colour-preview]'
    );

    const colourDropdown =
  overlay.querySelector(
    '[data-colour-dropdown]'
  );

const colourDropdownTrigger =
  overlay.querySelector(
    '[data-colour-dropdown-trigger]'
  );

const colourDropdownMenu =
  overlay.querySelector(
    '[data-colour-dropdown-menu]'
  );

const colourDropdownValue =
  overlay.querySelector(
    '[data-colour-dropdown-value]'
  );

const colourOptions =
  overlay.querySelectorAll(
    '[data-colour-option]'
  );

    const summaryDescription = overlay.querySelector(
      '[data-summary-description]'
    );

    const summaryColour = overlay.querySelector(
      '[data-summary-colour]'
    );

    const summaryPlacement = overlay.querySelector(
      '[data-summary-placement]'
    );

    const summaryPrice = overlay.querySelector(
      '[data-summary-price]'
    );

    const summaryProductVariant = overlay.querySelector(
  '[data-summary-product-variant]'
);

const summaryProductPrice = overlay.querySelector(
  '[data-summary-product-price]'
);

const summaryTotal = overlay.querySelector(
  '[data-summary-total]'
);

const quantityElement = overlay.querySelector(
  '[data-embroidery-quantity]'
);

const quantityMinus = overlay.querySelector(
  '[data-embroidery-quantity-minus]'
);

const quantityPlus = overlay.querySelector(
  '[data-embroidery-quantity-plus]'
);

const multipleEmbroidery = overlay.querySelector(
  '[data-embroidery-multiple]'
);

const multipleModeInputs = overlay.querySelectorAll(
  '[data-embroidery-multiple-mode]'
);

const embroideryJobsElement = overlay.querySelector(
  '[data-embroidery-jobs]'
);

if (!submitButton) {
  return;
}

    /*
     * =====================================================
     * STATE
     * =====================================================
     */

    const state = {
  mode: null,

  colour: null,
  spool: null,

  placement: null,

  font: null,

  text: '',
  textLeft: '',
  textRight: '',

  textTowel1: '',
  textTowel2: '',
  textTowel3: '',
  textTowel4: '',

  textTwoTowels1: '',
  textTwoTowels2: '',

  twoTowels1VariantId: null,
  twoTowels1Price: 0,
  
  twoTowels2VariantId: null,
  twoTowels2Price: 0,

  pillowLeftVariantId: null,
  pillowLeftPrice: 0,
  pillowRightVariantId: null,
  pillowRightPrice: 0,

  towel1VariantId: null,
  towel1Price: 0,
  towel2VariantId: null,
  towel2Price: 0,
  towel3VariantId: null,
  towel3Price: 0,
  towel4VariantId: null,
  towel4Price: 0,
  
  hasHeart: false,

  symbol: null,

  embroideryVariantId: null,
  embroideryPrice: 0,
  embroideryPriceFormatted: null,

  quantity: 1,
  multipleMode: 'same',

  loading: false
};

/*
 * Individual embroidery configurations.
 *
 * Used only when:
 * quantity > 1 &&
 * multipleMode === 'different'
 */
let embroideryJobs = [];

let currentEmbroideryIndex = null;

    /*
     * =====================================================
     * HELPERS
     * =====================================================
     */

    function createEmbroideryJob(configured = false) {
  return {
    mode: state.mode,

    colour: state.colour,
    spool: state.spool,

    placement: state.placement,

    font: state.font,

    text: state.text,

    textLeft: state.textLeft,
    textRight: state.textRight,

    textTowel1: state.textTowel1,
    textTowel2: state.textTowel2,
    textTowel3: state.textTowel3,
    textTowel4: state.textTowel4,

    textTwoTowels1:
  state.textTwoTowels1,

textTwoTowels2:
  state.textTwoTowels2,

twoTowels1VariantId:
  state.twoTowels1VariantId,

twoTowels1Price:
  state.twoTowels1Price,

twoTowels2VariantId:
  state.twoTowels2VariantId,

twoTowels2Price:
  state.twoTowels2Price,

    pillowLeftVariantId:
      state.pillowLeftVariantId,

    pillowLeftPrice:
      state.pillowLeftPrice,

    pillowRightVariantId:
      state.pillowRightVariantId,

    pillowRightPrice:
      state.pillowRightPrice,

    towel1VariantId: state.towel1VariantId,
    towel1Price: state.towel1Price,
    towel2VariantId: state.towel2VariantId,
    towel2Price: state.towel2Price,
    towel3VariantId: state.towel3VariantId,
    towel3Price: state.towel3Price,
    towel4VariantId: state.towel4VariantId,
    towel4Price: state.towel4Price,

    hasHeart: state.hasHeart,

    symbol: state.symbol,

    embroideryVariantId:
      state.embroideryVariantId,

    embroideryPrice:
      state.embroideryPrice,

    embroideryPriceFormatted:
      state.embroideryPriceFormatted,

    configured
  };
}

function isEmbroideryJobConfigured(job) {
  if (!job) {
    return false;
  }

  /*
   * Common requirements.
   */
  if (!job.colour) {
  return false;
}

const placementRadios =
  overlay.querySelectorAll(
    'input[type="radio"][data-embroidery-placement]'
  );

if (
  placementRadios.length > 0 &&
  !job.placement
) {
  return false;
}

  /*
   * Text embroidery.
   */
  if (job.mode === 'text') {
    if (!job.font) {
      return false;
    }

    /*
    * Pillow pair (Taies) or hand towel pair (Paires):
    * First OR second OR both.
    */

    if (config.isPillowPair || config.isHandTowelPair) {
      const leftLength =
        characterLength(
          job.textLeft || ''
        );

      const rightLength =
        characterLength(
          job.textRight || ''
        );

      const hasLeft =
        leftLength >= 1 &&
        leftLength <= getMaxCharacters();

      const hasRight =
        rightLength >= 1 &&
        rightLength <= getMaxCharacters();

      if (!hasLeft && !hasRight) {
        return false;
      }

      if (
        hasLeft &&
        !job.pillowLeftVariantId
      ) {
        return false;
      }

      if (
        hasRight &&
        !job.pillowRightVariantId
      ) {
        return false;
      }

      return true;
    }

    if (config.isTowelQuad) {
      const towel1Length =
        characterLength(
          job.textTowel1 || ''
        );

      const towel2Length =
        characterLength(
          job.textTowel2 || ''
        );

      const towel3Length =
        characterLength(
          job.textTowel3 || ''
        );

      const towel4Length =
        characterLength(
          job.textTowel4 || ''
        );

      const hasTowel1 =
        towel1Length >= 1 &&
        towel1Length <= getMaxCharacters();

      const hasTowel2 =
        towel2Length >= 1 &&
        towel2Length <= getMaxCharacters();

      const hasTowel3 =
        towel3Length >= 1 &&
        towel3Length <= getMaxCharacters();

      const hasTowel4 =
        towel4Length >= 1 &&
        towel4Length <= getMaxCharacters();

      if (
        !hasTowel1 &&
        !hasTowel2 &&
        !hasTowel3 &&
        !hasTowel4
      ) {
        return false;
      }

      if (
        hasTowel1 &&
        !job.towel1VariantId
      ) {
        return false;
      }

      if (
        hasTowel2 &&
        !job.towel2VariantId
      ) {
        return false;
      }

      if (
        hasTowel3 &&
        !job.towel3VariantId
      ) {
        return false;
      }

      if (
        hasTowel4 &&
        !job.towel4VariantId
      ) {
        return false;
      }

      return true;

}

if (config.isTwoTowels) {
  const towel1Length =
    characterLength(
      job.textTwoTowels1 || ''
    );

  const towel2Length =
    characterLength(
      job.textTwoTowels2 || ''
    );

  const hasTowel1 =
    towel1Length >= 1 &&
    towel1Length <= getMaxCharacters();

  const hasTowel2 =
    towel2Length >= 1 &&
    towel2Length <= getMaxCharacters();

  if (!hasTowel1 && !hasTowel2) {
    return false;
  }

  if (
    hasTowel1 &&
    !job.twoTowels1VariantId
  ) {
    return false;
  }

  if (
    hasTowel2 &&
    !job.twoTowels2VariantId
  ) {
    return false;
  }

  return true;
}

/*
 * Standard text.
 */
    return Boolean(
      job.embroideryVariantId &&
      job.text &&
      job.text.trim()
    );
  }

  /*
   * Symbol embroidery.
   */
  if (job.mode === 'symbol') {
    return Boolean(
      job.embroideryVariantId &&
      job.symbol
    );
  }

  return false;
}

function getMaxCharacters() {
  const placements = overlay.querySelectorAll(
    '[data-embroidery-placement]'
  );

  /*
   * No placement restriction:
   * use the product default.
   */
  if (!placements.length) {
    return productMaxCharacters;
  }

  /*
   * Multiple placements:
   * use the selected placement.
   *
   * Single placement:
   * use the hidden placement.
   */
  const placement =
    overlay.querySelector(
      'input[type="radio"][data-embroidery-placement]:checked'
    ) ||
    overlay.querySelector(
      'input[type="hidden"][data-embroidery-placement]'
    );

  if (!placement) {
    return productMaxCharacters;
  }

  const placementMax =
    Number(
      placement.dataset.maxCharacters
    );

  return placementMax > 0
    ? placementMax
    : productMaxCharacters;
}

function updateCharacterLimitUI() {
  const max = getMaxCharacters();

  /*
   * Standard single text field.
   */
  if (textInput) {
    textInput.maxLength = max;
    textInput.placeholder =
      charactersMaxTemplate.replace('__COUNT__', max);

    if (characterMax) {
      characterMax.textContent =
        String(max);
    }
  }

  /*
   * Pillow pair fields.
   */
  [
    {
      input: textInputLeft,
      maxElement: characterMaxLeft
    },
    {
      input: textInputRight,
      maxElement: characterMaxRight
    },
    {
      input: textInputTowel1,
      maxElement: characterMaxTowel1
    },
    {
      input: textInputTowel2,
      maxElement: characterMaxTowel2
    },
    {
      input: textInputTowel3,
      maxElement: characterMaxTowel3
    },
    {
      input: textInputTowel4,
      maxElement: characterMaxTowel4
    },
    {
  input: textInputTwoTowels1,
  maxElement: characterMaxTwoTowels1
},
{
  input: textInputTwoTowels2,
  maxElement: characterMaxTwoTowels2
}
  ].forEach(({ input, maxElement }) => {
    if (!input) {
      return;
    }

    input.maxLength = max;
    input.placeholder =
      charactersMaxTemplate.replace('__COUNT__', max);

    if (maxElement) {
      maxElement.textContent =
        String(max);
    }
  });
}

function updatePillowTextCounter(
  input,
  counter
) {
  if (!input || !counter) {
    return;
  }

  counter.textContent =
    String(
      characterLength(
        input.value
      )
    );
}

function saveCurrentEmbroideryJob() {
  if (
    currentEmbroideryIndex === null ||
    !embroideryJobs[currentEmbroideryIndex]
  ) {
    return;
  }

  const job =
    createEmbroideryJob();

  job.configured =
    isEmbroideryJobConfigured(job);

  embroideryJobs[currentEmbroideryIndex] =
    job;

  renderEmbroideryJobs();
}

function loadEmbroideryJob(index) {
  const job = embroideryJobs[index];

  if (!job) {
    return;
  }

  currentEmbroideryIndex = index;

  /*
   * MODE
   */

  overlay
    .querySelectorAll(
      '[data-embroidery-mode]'
    )
    .forEach(input => {
      input.checked =
        input.value === job.mode;
    });



  /*
 * COLOUR
 */

if (colourSelect) {
  const selectedOption =
    Array.from(colourOptions).find(
      option =>
        option.dataset.value === job.colour
    );

  if (selectedOption) {
    const value =
      selectedOption.dataset.value || '';

    const hex =
      selectedOption.dataset.hex || '';

    const spool =
      selectedOption.dataset.spool || '';

    /*
     * Restore stored colour data
     */

    colourSelect.value =
      value;

    colourSelect.dataset.hex =
      hex;

    colourSelect.dataset.spool =
      spool;


    /*
     * Restore visible dropdown
     */

    if (colourDropdownValue) {
      colourDropdownValue.textContent =
        value;
    }

    if (colourPreview) {
      colourPreview.style.backgroundColor =
        hex;
    }


    /*
     * Restore selected state
     */

    colourOptions.forEach(option => {
      const selected =
        option === selectedOption;

      option.classList.toggle(
        'embroidery-colour-dropdown__option--selected',
        selected
      );

      const check =
        option.querySelector(
          '.embroidery-colour-dropdown__check'
        );

      if (check) {
        check.textContent =
          selected ? '✓' : '';
      }
    });
  }
}

  

  /*
   * PLACEMENT
   */

  overlay
    .querySelectorAll(
      'input[type="radio"][data-embroidery-placement]'
    )
    .forEach(input => {
      input.checked =
        input.value === job.placement;
    });

  /*
   * FONT
   */

  overlay
    .querySelectorAll(
      '[data-embroidery-font]'
    )
    .forEach(input => {
      input.checked =
        input.value === job.font;
    });

  /*
   * TEXT
   */

  if (textInput) {
    textInput.value =
      job.text || '';
  }

  if (textInputLeft) {
  textInputLeft.value =
    job.textLeft || '';

  updatePillowTextCounter(
    textInputLeft,
    characterCountLeft
  );
}

if (textInputRight) {
  textInputRight.value =
    job.textRight || '';

  updatePillowTextCounter(
    textInputRight,
    characterCountRight
  );
}

if (textInputTowel1) {
  textInputTowel1.value =
    job.textTowel1 || '';

  updatePillowTextCounter(
    textInputTowel1,
    characterCountTowel1
  );
}

if (textInputTowel2) {
  textInputTowel2.value =
    job.textTowel2 || '';

  updatePillowTextCounter(
    textInputTowel2,
    characterCountTowel2
  );
}

if (textInputTowel3) {
  textInputTowel3.value =
    job.textTowel3 || '';

  updatePillowTextCounter(
    textInputTowel3,
    characterCountTowel3
  );
}

if (textInputTowel4) {
  textInputTowel4.value =
    job.textTowel4 || '';

  updatePillowTextCounter(
    textInputTowel4,
    characterCountTowel4
  );
}

if (textInputTwoTowels1) {
  textInputTwoTowels1.value =
    job.textTwoTowels1 || '';

  updatePillowTextCounter(
    textInputTwoTowels1,
    characterCountTwoTowels1
  );
}

if (textInputTwoTowels2) {
  textInputTwoTowels2.value =
    job.textTwoTowels2 || '';

  updatePillowTextCounter(
    textInputTwoTowels2,
    characterCountTwoTowels2
  );
}

  /*
   * SYMBOL
   */

  overlay
    .querySelectorAll(
      '[data-embroidery-symbol]'
    )
    .forEach(input => {
      input.checked =
        input.value === job.symbol;
    });

  /*
   * Re-read the restored controls.
   */

  updateState();

  renderEmbroideryJobs();
}

    function getChecked(selector) {
      return overlay.querySelector(
        `${selector}:checked`
      );
    }

    function syncEmbroideryJobs() {
  /*
   * Separate configurations only exist in
   * "different" mode.
   */
  if (
    state.quantity <= 1 ||
    state.multipleMode !== 'different'
  ) {
    embroideryJobs = [];
    currentEmbroideryIndex = null;

    renderEmbroideryJobs();

    return;
  }

  /*
   * Preserve configurations that already exist.
   *
   * New products initially inherit the currently
   * configured embroidery.
   */
  while (
    embroideryJobs.length <
    state.quantity
  ) {
    embroideryJobs.push(
      createEmbroideryJob()
    );
  }

  /*
   * Quantity may also have been reduced.
   */
  if (
    embroideryJobs.length >
    state.quantity
  ) {
    embroideryJobs =
      embroideryJobs.slice(
        0,
        state.quantity
      );
  }

  /*
   * Start with the first product.
   */
  if (
    currentEmbroideryIndex === null ||
    currentEmbroideryIndex >=
      embroideryJobs.length
  ) {
    currentEmbroideryIndex = 0;
  }

  renderEmbroideryJobs();
}


function renderEmbroideryJobs() {
  if (!embroideryJobsElement) {
    return;
  }

  const show =
    state.quantity > 1 &&
    state.multipleMode === 'different';

  embroideryJobsElement.hidden =
    !show;

  if (!show) {
    embroideryJobsElement.innerHTML = '';
    return;
  }

  embroideryJobsElement.innerHTML =
    embroideryJobs
      .map((job, index) => {
        const active =
          index === currentEmbroideryIndex;

        const status =
          job.configured
            ? configuredLabel
            : toConfigureLabel;

        return `
          <button
            type="button"
            class="embroidery-job${active ? ' embroidery-job--active' : ''}"
            data-embroidery-job="${index}"
          >
            <span class="embroidery-job__name">
              ${productLabel} ${index + 1}
            </span>

            <span
  class="embroidery-job__status"
  data-configured="${job.configured}"
>
              ${status}
            </span>
          </button>
        `;
      })
      .join('');
}

if (embroideryJobsElement) {
  embroideryJobsElement.addEventListener(
    'click',
    event => {
      const button =
        event.target.closest(
          '[data-embroidery-job]'
        );

      if (!button) {
        return;
      }

      const index =
        Number(
          button.dataset.embroideryJob
        );

      if (
        !Number.isInteger(index) ||
        !embroideryJobs[index] ||
        index === currentEmbroideryIndex
      ) {
        return;
      }

      /*
       * Save the product we're leaving.
       */

      updateState();

      saveCurrentEmbroideryJob();

      /*
       * Load the product they clicked.
       */

      loadEmbroideryJob(index);
    }
  );
}

    /*
     * =====================================================
     * CHARACTER HANDLING
     * =====================================================
     *
     * ❤️ counts as ONE character.
     * Maximum total is defined by placement or product.
     */

    const graphemeSegmenter =
      typeof Intl !== 'undefined' &&
      Intl.Segmenter
        ? new Intl.Segmenter(
            undefined,
            {
              granularity: 'grapheme'
            }
          )
        : null;

    function characters(value) {
      value = value || '';

      if (graphemeSegmenter) {
        return Array.from(
          graphemeSegmenter.segment(value),
          item => item.segment
        );
      }

      const placeholder = '\uE000';

      const normalised = value
        .replaceAll(
          '❤️',
          placeholder
        )
        .replaceAll(
          '❤',
          placeholder
        );

      return Array.from(
        normalised
      ).map(character => {
        return character === placeholder
          ? '❤️'
          : character;
      });
    }

    function characterLength(value) {
      return characters(value).length;
    }

    function limitText(value, max) {
      return characters(value)
        .slice(0, max)
        .join('');
    }

    /*
     * =====================================================
     * HEART
     * =====================================================
     */

    function isHeart(character) {
      return (
        character === '❤️' ||
        character === '❤'
      );
    }

    function containsHeart(value) {
      return characters(value).some(
        isHeart
      );
    }

    function enforceSingleHeart(value) {
      let found = false;

      return characters(value)
        .filter(character => {
          if (!isHeart(character)) {
            return true;
          }

          if (found) {
            return false;
          }

          found = true;

          return true;
        })
        .map(character => {
          return isHeart(character)
            ? '❤️'
            : character;
        })
        .join('');
    }

    /*
     * =====================================================
     * MONEY
     * =====================================================
     */

    function formatMoney(cents) {
      const amount =
        Number(cents || 0) / 100;

      try {
        return new Intl.NumberFormat(
          document.documentElement.lang ||
            'fr-FR',
          {
            style: 'currency',
            currency:
              config.currency ||
              'EUR'
          }
        ).format(amount);
      } catch (error) {
        return `${amount.toFixed(2)} €`;
      }
    }

    /*
     * =====================================================
     * EMBROIDERY GROUP ID
     * =====================================================
     */

    function createEmbroideryId() {
      return (
        'EMB-' +
        Date.now() +
        '-' +
        Math.random()
          .toString(36)
          .slice(2, 8)
          .toUpperCase()
      );
    }

    /*
     * =====================================================
     * CURRENT PRODUCT VARIANT
     * =====================================================
     */

    function getSelectedPackEmbroideryVariantId() {
  const combinationHandle =
    decodeURIComponent(
      window.location.hash.replace(/^#/, '')
    );

  if (!combinationHandle) {
    return null;
  }

  const combination =
    document.querySelector(
      `.pack-product__combination[data-combination="${CSS.escape(combinationHandle)}"]`
    );

  if (!combination) {
    return null;
  }

  const taiesSelect =
    combination.querySelector(
      '[data-pack-embroidery-target="taies"]'
    );

  if (
    !taiesSelect ||
    !taiesSelect.value
  ) {
    return null;
  }

  return Number(
    taiesSelect.value
  );
}

    function getSelectedProductVariantId() {
  const packVariantId =
    getSelectedPackEmbroideryVariantId();

  if (packVariantId) {
    return packVariantId;
  }

  const productId =
    root.dataset.productId;

      if (productId) {
        const productFormComponent =
          document.querySelector(
            `product-form-component[data-product-id="${productId}"]`
          );

        const productForm =
          productFormComponent?.querySelector(
            'form[action*="/cart/add"]'
          );

        const productIdInput =
          productForm?.querySelector(
            '[name="id"]'
          );

        if (
          productIdInput &&
          productIdInput.value
        ) {
          return Number(
            productIdInput.value
          );
        }
      }

      /*
       * Fallback.
       */

      const productForms = Array.from(
        document.querySelectorAll(
          'form[action*="/cart/add"]'
        )
      );

      for (const form of productForms) {
        const idInput = form.querySelector(
          '[name="id"]'
        );

        if (
          idInput &&
          idInput.value
        ) {
          return Number(
            idInput.value
          );
        }
      }

      return null;
    }

    function getSelectedProductVariant() {
  const variantId =
    getSelectedProductVariantId();

  if (!variantId) {
    return null;
  }

  const productData =
    window.ShopifyAnalytics?.meta?.product;

  const variants =
    productData?.variants;

  if (!Array.isArray(variants)) {
    return null;
  }

  return variants.find(
    variant =>
      Number(variant.id) ===
      Number(variantId)
  ) || null;
}

    /*
     * =====================================================
     * INITIAL MODE
     * =====================================================
     */

    function initialiseMode() {
  if (
    config.configuredType ===
    'Texts'
  ) {
    state.mode = 'text';
    return;
  }

  if (
    config.configuredType ===
    'Symbols'
  ) {
    state.mode = 'symbol';
    return;
  }

  if (
    config.configuredType ===
    'Texts & Symbols'
  ) {
    const mode = getChecked(
      '[data-embroidery-mode]'
    );

    state.mode = mode
      ? mode.value
      : null;
  }
}

function resolveTextVariant(text) {
  const length =
    characterLength(text);

  const hasHeart =
    containsHeart(text);

  let variant = null;

  /*
   * SMALL
   */
  if (
    length >= 1 &&
    length <= 4
  ) {
    variant = hasHeart
      ? config.textVariants.smallHeart
      : config.textVariants.small;
  }

  /*
   * MEDIUM
   */
  if (
    length >= 5 &&
    length <= 11
  ) {
    variant = hasHeart
      ? config.textVariants.mediumHeart
      : config.textVariants.medium;
  }

  /*
   * LARGE
   */
  if (
    length >= 12 &&
    length <= 20
  ) {
    variant = hasHeart
      ? config.textVariants.largeHeart
      : config.textVariants.large;
  }

  if (
    !variant ||
    !variant.id
  ) {
    return null;
  }

  return {
    id: Number(variant.id),
    price: Number(variant.price || 0),
    formatted:
      variant.formatted || null,
    hasHeart
  };
}

    /*
     * =====================================================
     * TEXT VARIANT
     * =====================================================
     *
     * 1–4   = Small
     * 5–11  = Medium
     * 12–20 = Large
     */

    function updateTextVariant() {
  const resolved =
    resolveTextVariant(
      state.text
    );

  state.hasHeart =
    containsHeart(
      state.text
    );

  if (!resolved) {
    state.embroideryVariantId =
      null;

    state.embroideryPrice =
      0;

    state.embroideryPriceFormatted =
      null;

    return;
  }

  state.embroideryVariantId =
    resolved.id;

  state.embroideryPrice =
    resolved.price;

  state.embroideryPriceFormatted =
    resolved.formatted;
}

function updatePillowTextVariants() {
  const left =
    resolveTextVariant(
      state.textLeft
    );

  const right =
    resolveTextVariant(
      state.textRight
    );

  state.pillowLeftVariantId =
    left?.id || null;

  state.pillowLeftPrice =
    left?.price || 0;

  state.pillowRightVariantId =
    right?.id || null;

  state.pillowRightPrice =
    right?.price || 0;

  /*
   * Keep the existing summary/pricing system
   * working by exposing the combined price.
   */
  state.embroideryPrice =
    state.pillowLeftPrice +
    state.pillowRightPrice;

  state.embroideryPriceFormatted =
    state.embroideryPrice > 0
      ? formatMoney(
          state.embroideryPrice
        )
      : null;

  /*
   * For Taies there is intentionally no single
   * embroidery service variant.
   */
  state.embroideryVariantId =
    null;

  state.hasHeart =
    containsHeart(state.textLeft) ||
    containsHeart(state.textRight);
}

function updateTowelTextVariants() {
  const towel1 =
    resolveTextVariant(state.textTowel1);

  const towel2 =
    resolveTextVariant(state.textTowel2);

  const towel3 =
    resolveTextVariant(state.textTowel3);

  const towel4 =
    resolveTextVariant(state.textTowel4);

  state.towel1VariantId =
    towel1?.id || null;
  state.towel1Price =
    towel1?.price || 0;

  state.towel2VariantId =
    towel2?.id || null;
  state.towel2Price =
    towel2?.price || 0;

  state.towel3VariantId =
    towel3?.id || null;
  state.towel3Price =
    towel3?.price || 0;

  state.towel4VariantId =
    towel4?.id || null;
  state.towel4Price =
    towel4?.price || 0;

  state.embroideryPrice =
    state.towel1Price +
    state.towel2Price +
    state.towel3Price +
    state.towel4Price;

  state.embroideryPriceFormatted =
    state.embroideryPrice > 0
      ? formatMoney(state.embroideryPrice)
      : null;

  state.embroideryVariantId =
    null;

  state.hasHeart =
    containsHeart(state.textTowel1) ||
    containsHeart(state.textTowel2) ||
    containsHeart(state.textTowel3) ||
    containsHeart(state.textTowel4);
}

function updateTwoTowelsTextVariants() {
  const towel1 =
    resolveTextVariant(
      state.textTwoTowels1
    );

  const towel2 =
    resolveTextVariant(
      state.textTwoTowels2
    );

  state.twoTowels1VariantId =
    towel1?.id || null;

  state.twoTowels1Price =
    towel1?.price || 0;

  state.twoTowels2VariantId =
    towel2?.id || null;

  state.twoTowels2Price =
    towel2?.price || 0;

  state.embroideryPrice =
    state.twoTowels1Price +
    state.twoTowels2Price;

  state.embroideryPriceFormatted =
    state.embroideryPrice > 0
      ? formatMoney(
          state.embroideryPrice
        )
      : null;

  /*
   * There is deliberately no single embroidery
   * service variant for 2-serviettes.
   */
  state.embroideryVariantId =
    null;

  state.hasHeart =
    containsHeart(
      state.textTwoTowels1
    ) ||
    containsHeart(
      state.textTwoTowels2
    );
}

    /*
     * =====================================================
     * READ STATE
     * =====================================================
     */

    function updateState() {
      /*
       * MODE
       */

      if (
        config.configuredType ===
        'Texts & Symbols'
      ) {
        const mode = getChecked(
          '[data-embroidery-mode]'
        );

        state.mode = mode
          ? mode.value
          : null;
      }

      /*
       * COLOUR
       */

      /*
 * COLOUR
 */

if (colourSelect) {
  state.colour =
    colourSelect.value ||
    null;

  state.spool =
    colourSelect.dataset.spool ||
    null;

  if (colourPreview) {
    colourPreview.style.backgroundColor =
      colourSelect.dataset.hex ||
      'transparent';
  }
}

      /*
       * PLACEMENT
       */

      const placement =
        getChecked(
          '[data-embroidery-placement]'
        ) ||
        overlay.querySelector(
          'input[type="hidden"][data-embroidery-placement]'
        );

      state.placement = placement
        ? placement.value
        : null;

      updateCharacterLimitUI();

      /*
       * FONT
       */

      const font = getChecked(
        '[data-embroidery-font]'
      );

      state.font = font
        ? font.value
        : null;

      /*
       * TEXT
       */

      state.text = textInput
  ? textInput.value.trim()
  : '';

state.textLeft = textInputLeft
  ? textInputLeft.value.trim()
  : '';

state.textRight = textInputRight
  ? textInputRight.value.trim()
  : '';

state.textTowel1 = textInputTowel1
  ? textInputTowel1.value.trim()
  : '';

state.textTowel2 = textInputTowel2
  ? textInputTowel2.value.trim()
  : '';

state.textTowel3 = textInputTowel3
  ? textInputTowel3.value.trim()
  : '';

state.textTowel4 = textInputTowel4
  ? textInputTowel4.value.trim()
  : '';

state.textTwoTowels1 = textInputTwoTowels1
  ? textInputTwoTowels1.value.trim()
  : '';

state.textTwoTowels2 = textInputTwoTowels2
  ? textInputTwoTowels2.value.trim()
  : '';

      /*
       * SYMBOL
       */

      const symbol = getChecked(
        '[data-embroidery-symbol]'
      );

      if (
        state.mode === 'symbol'
      ) {
        state.hasHeart = false;

        if (symbol) {
          state.symbol =
            symbol.value;

          state.embroideryVariantId =
            Number(
              symbol.dataset.variantId
            );

          state.embroideryPrice =
            Number(
              symbol.dataset.price
            );

          state.embroideryPriceFormatted =
            symbol.dataset.priceFormatted;
        } else {
          state.symbol =
            null;

          state.embroideryVariantId =
            null;

          state.embroideryPrice =
            0;

          state.embroideryPriceFormatted =
            null;
        }
      }

      /*
       * TEXT
       */

      if (
  state.mode === 'text'
) {
  state.symbol = null;

  if (config.isPillowPair || config.isHandTowelPair) {
    updatePillowTextVariants();
  } else if (config.isTowelQuad) {
    updateTowelTextVariants();
  } else if (config.isTwoTowels) {
    updateTwoTowelsTextVariants();
  } else {
    updateTextVariant();
  }

}

      /*
       * NOTHING SELECTED
       */

      if (!state.mode) {
  state.embroideryVariantId =
    null;

  state.embroideryPrice =
    0;

  state.embroideryPriceFormatted =
    null;

  state.pillowLeftVariantId =
    null;

  state.pillowLeftPrice =
    0;

  state.pillowRightVariantId =
    null;

  state.pillowRightPrice =
    0;

  state.towel1VariantId =
  null;

state.towel1Price =
  0;

state.towel2VariantId =
  null;

state.towel2Price =
  0;

state.towel3VariantId =
  null;

state.towel3Price =
  0;

state.towel4VariantId =
  null;

state.towel4Price =
  0;

  state.twoTowels1VariantId =
  null;

state.twoTowels1Price =
  0;

state.twoTowels2VariantId =
  null;

state.twoTowels2Price =
  0;

  state.hasHeart =
    false;
}

      updateUI();

      if (
  state.multipleMode === 'different' &&
  currentEmbroideryIndex !== null &&
  embroideryJobs[currentEmbroideryIndex]
) {
  const job =
    createEmbroideryJob();

  job.configured =
    isEmbroideryJobConfigured(job);

  embroideryJobs[currentEmbroideryIndex] =
    job;

  renderEmbroideryJobs();
}
    }

    /*
     * =====================================================
     * UI
     * =====================================================
     */

    function updateUI() {
      /*
       * PANELS
       */

      if (textPanel) {
        textPanel.hidden =
          state.mode !== 'text';
      }

      if (symbolPanel) {
        symbolPanel.hidden =
          state.mode !== 'symbol';
      }

      /*
       * CHARACTER COUNT
       */

      if (characterCount) {
        characterCount.textContent =
          characterLength(
            textInput
              ? textInput.value
              : ''
          );
      }

      /*
       * HEART BUTTON
       */

      if (heartButton) {
        heartButton.disabled =
          state.hasHeart ||
          characterLength(
            textInput
              ? textInput.value
              : ''
          ) >= getMaxCharacters();
      }

      /*
       * DESCRIPTION
       */

      if (summaryDescription) {
        if (
          state.mode === 'text'
        ) {
          const parts = [];

          if (config.isHandTowelPair) {
            if (state.textLeft) {
              parts.push(`Serviette 1 : ${state.textLeft}`);
            }

            if (state.textRight) {
              parts.push(`Serviette 2 : ${state.textRight}`);
            }
          } else if (state.text) {
            parts.push(
              `${state.text}`
            );
          }

          if (state.font) {
            parts.push(
              state.font
            );
          }

          summaryDescription.textContent =
            parts.length
              ? parts.join(' · ')
              : toEnterLabel;

        } else if (
          state.mode === 'symbol'
        ) {

          summaryDescription.textContent =
            state.symbol ||
            toChooseLabel;

        } else {

          summaryDescription.textContent =
            toChooseLabel;

        }
      }

      /*
       * COLOUR
       */

      if (summaryColour) {
        summaryColour.textContent =
          state.colour ||
          '—';
      }

      /*
       * PLACEMENT
       */

      if (summaryPlacement) {
        summaryPlacement.textContent =
          state.placement ||
          '—';
      }

      /*
       * PRICE
       */

      renderSummaryPrice();
      renderProductSummary();
      validate();
    }

    /*
     * =====================================================
     * VALIDATION
     * =====================================================
     */

    function validate() {
      let valid =
  !!state.mode &&
  !!state.colour;

  /*
 * Standard embroidery requires one
 * resolved service variant.
 */
if (
  !config.isPillowPair &&
  !config.isHandTowelPair &&
  !config.isTowelQuad &&
  !config.isTwoTowels
) {
  valid =
    valid &&
    !!state.embroideryVariantId;
}

      const placementRadios =
        overlay.querySelectorAll(
          'input[type="radio"][data-embroidery-placement]'
        );

      if (
        placementRadios.length > 0 &&
        !state.placement
      ) {
        valid = false;
      }

      /*
       * TEXT
       */

      if (
  state.mode === 'text'
) {
  
  /*
  * Pillow pair (Taies) or hand towel pair (Paires):
  * First OR second OR both.
  */

  if (config.isPillowPair || config.isHandTowelPair) {
    const leftLength =
      characterLength(
        state.textLeft
      );

    const rightLength =
      characterLength(
        state.textRight
      );

    const hasLeft =
      leftLength >= 1 &&
      leftLength <= getMaxCharacters();

    const hasRight =
      rightLength >= 1 &&
      rightLength <= getMaxCharacters();

    const leftResolved =
  !hasLeft ||
  !!state.pillowLeftVariantId;

const rightResolved =
  !hasRight ||
  !!state.pillowRightVariantId;

valid =
  valid &&
  !!state.font &&
  (hasLeft || hasRight) &&
  leftResolved &&
  rightResolved;
  }

  else if (config.isTowelQuad) {
  const towel1Length =
    characterLength(state.textTowel1);

  const towel2Length =
    characterLength(state.textTowel2);

  const towel3Length =
    characterLength(state.textTowel3);

  const towel4Length =
    characterLength(state.textTowel4);

  const hasTowel1 =
    towel1Length >= 1 &&
    towel1Length <= getMaxCharacters();

  const hasTowel2 =
    towel2Length >= 1 &&
    towel2Length <= getMaxCharacters();

  const hasTowel3 =
    towel3Length >= 1 &&
    towel3Length <= getMaxCharacters();

  const hasTowel4 =
    towel4Length >= 1 &&
    towel4Length <= getMaxCharacters();

  const towel1Resolved =
    !hasTowel1 ||
    !!state.towel1VariantId;

  const towel2Resolved =
    !hasTowel2 ||
    !!state.towel2VariantId;

  const towel3Resolved =
    !hasTowel3 ||
    !!state.towel3VariantId;

  const towel4Resolved =
    !hasTowel4 ||
    !!state.towel4VariantId;

  valid =
    valid &&
    !!state.font &&
    (
      hasTowel1 ||
      hasTowel2 ||
      hasTowel3 ||
      hasTowel4
    ) &&
    towel1Resolved &&
    towel2Resolved &&
    towel3Resolved &&
    towel4Resolved;
}

else if (config.isTwoTowels) {
  const towel1Length =
    characterLength(
      state.textTwoTowels1
    );

  const towel2Length =
    characterLength(
      state.textTwoTowels2
    );

  const hasTowel1 =
    towel1Length >= 1 &&
    towel1Length <= getMaxCharacters();

  const hasTowel2 =
    towel2Length >= 1 &&
    towel2Length <= getMaxCharacters();

  const towel1Resolved =
    !hasTowel1 ||
    !!state.twoTowels1VariantId;

  const towel2Resolved =
    !hasTowel2 ||
    !!state.twoTowels2VariantId;

  valid =
    valid &&
    !!state.font &&
    (hasTowel1 || hasTowel2) &&
    towel1Resolved &&
    towel2Resolved;
}

/*
 * Standard text embroidery.
 */
else {
    const length =
      characterLength(
        state.text
      );

    valid =
      valid &&
      !!state.font &&
      length >= 1 &&
      length <= getMaxCharacters();
  }
}

      /*
       * SYMBOL
       */

      if (
        state.mode === 'symbol'
      ) {
        valid =
          valid &&
          !!state.symbol;
      }

      /*
 * DIFFERENT EMBROIDERIES
 *
 * Every physical product must have
 * a complete embroidery configuration.
 */

if (
  state.quantity > 1 &&
  state.multipleMode === 'different'
) {
  valid =
    valid &&
    embroideryJobs.length ===
      state.quantity &&
    embroideryJobs.every(
      job =>
        isEmbroideryJobConfigured(job)
    );
}

      submitButton.disabled =
        !valid ||
        state.loading;
    }

    /*
     * =====================================================
     * MODAL
     * =====================================================
     */

    function syncPackEmbroideryColours() {
  if (
    !colourDropdown ||
    !colourSelect ||
    !colourDropdownValue ||
    !colourPreview
  ) {
    return;
  }

  if (
    !colourDropdown.hasAttribute(
      'data-pack-embroidery-colours'
    )
  ) {
    return;
  }

const activeCombination = document.querySelector(
  'pack-product .pack-product__colour.is-active'
);

const combinationHandle =
  activeCombination?.dataset.packCombination ||
  decodeURIComponent(
    window.location.hash.replace(/^#/, '')
  );

  if (!combinationHandle) {
    return;
  }

  const options = Array.from(colourOptions);

  /*
   * 2-serviettes:
   *
   * The Liquid data already identifies the first and
   * second embroidery-capable products of each combination.
   *
   * For the shared colour selector we use the first
   * embroidery-capable product.
   */
  const twoTowelsIndex =
    config.isTwoTowels
      ? '1'
      : null;

  const availableOptions = [];

  options.forEach(option => {
    const matches =
      config.isTwoTowels
        ? (
            option.hasAttribute(
              'data-two-towels-colour-option'
            ) &&
            option.dataset.packCombination ===
              combinationHandle &&
            option.dataset.twoTowelsIndex ===
              twoTowelsIndex
          )
        : (
            option.dataset.packCombination ===
              combinationHandle
          );

    option.hidden = !matches;
    option.style.display =
      matches ? '' : 'none';

    option.classList.remove(
      'embroidery-colour-dropdown__option--selected'
    );

    const check = option.querySelector(
      '.embroidery-colour-dropdown__check'
    );

    if (check) {
      check.textContent = '';
    }

    if (matches) {
      availableOptions.push(option);
    }
  });

  /*
   * No colours available.
   */
  if (!availableOptions.length) {
    colourSelect.value = '';
    colourSelect.dataset.hex = '';
    colourSelect.dataset.spool = '';

    colourDropdownValue.textContent = '';
    colourPreview.style.backgroundColor = '';

    return;
  }

  /*
   * Select first permitted colour.
   */
  const firstOption = availableOptions[0];

  const value =
    firstOption.dataset.value || '';

  const hex =
    firstOption.dataset.hex || '';

  const spool =
    firstOption.dataset.spool || '';

  colourSelect.value = value;
  colourSelect.dataset.hex = hex;
  colourSelect.dataset.spool = spool;

  colourDropdownValue.textContent = value;

  colourPreview.style.backgroundColor =
    hex;

  firstOption.classList.add(
    'embroidery-colour-dropdown__option--selected'
  );

  const check = firstOption.querySelector(
    '.embroidery-colour-dropdown__check'
  );

  if (check) {
    check.textContent = '✓';
  }
}


    function openModal() {
  overlay.hidden = false;

  document.body.classList.add(
    'embroidery-modal-open'
  );

  syncPackEmbroideryColours();

  if (colourDropdownMenu) {
    colourDropdownMenu.hidden = true;
  }

  if (colourDropdown) {
    colourDropdown.classList.remove(
      'embroidery-colour-dropdown--open'
    );
  }

  if (colourDropdownTrigger) {
    colourDropdownTrigger.setAttribute(
      'aria-expanded',
      'false'
    );
  }

  updateState();
}

    function closeModal() {
      overlay.hidden = true;

      document.body.classList.remove(
        'embroidery-modal-open'
      );
    }

    if (openButton) {
      openButton.addEventListener(
        'click',
        openModal
      );
    }

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        closeModal
      );
    }

    overlay.addEventListener(
      'click',
      event => {
        if (
          event.target === overlay
        ) {
          closeModal();
        }
      }
    );

    /*
 * =====================================================
 * COLOUR DROPDOWN
 * =====================================================
 */

if (
  colourDropdown &&
  colourDropdownTrigger &&
  colourDropdownMenu
) {
  colourDropdownTrigger.addEventListener(
    'click',
    () => {
      const isOpen =
        !colourDropdownMenu.hidden;

      colourDropdownMenu.hidden =
        isOpen;

      colourDropdown.classList.toggle(
        'embroidery-colour-dropdown--open',
        !isOpen
      );

      colourDropdownTrigger.setAttribute(
        'aria-expanded',
        String(!isOpen)
      );
    }
  );


  colourOptions.forEach(option => {
    option.addEventListener(
      'click',
      () => {
        const value =
          option.dataset.value || '';

        const hex =
          option.dataset.hex || '';

        const spool =
          option.dataset.spool || '';

        /*
         * Update stored value
         */

        colourSelect.value =
          value;

        colourSelect.dataset.hex =
          hex;

        colourSelect.dataset.spool =
          spool;


        /*
         * Update trigger
         */

        if (colourDropdownValue) {
          colourDropdownValue.textContent =
            value;
        }

        if (colourPreview) {
          colourPreview.style.backgroundColor =
            hex;
        }


        /*
         * Update selected option
         */

        colourOptions.forEach(item => {
          const selected =
            item === option;

          item.classList.toggle(
            'embroidery-colour-dropdown__option--selected',
            selected
          );

          const check =
            item.querySelector(
              '.embroidery-colour-dropdown__check'
            );

          if (check) {
            check.textContent =
              selected ? '✓' : '';
          }
        });


        /*
         * Close menu
         */

        colourDropdownMenu.hidden =
          true;

        colourDropdown.classList.remove(
          'embroidery-colour-dropdown--open'
        );

        colourDropdownTrigger.setAttribute(
          'aria-expanded',
          'false'
        );


        /*
         * Update configurator state
         */

        updateState();
      }
    );
  });
}

    /*
     * =====================================================
     * CHANGE EVENTS
     * =====================================================
     */

    overlay.addEventListener(
      'change',
      event => {
        if (
          event.target.matches(
            '[data-embroidery-mode], ' +
            '[data-embroidery-colour], ' +
            '[data-embroidery-placement], ' +
            '[data-embroidery-font], ' +
            '[data-embroidery-symbol]'
          )
        ) {
          updateState();
        }
      }
    );

    /*
     * =====================================================
     * TEXT INPUT
     * =====================================================
     */

    if (textInput) {
      textInput.addEventListener(
        'input',
        () => {
          let value =
            textInput.value;

          /*
           * Maximum ONE heart.
           */

          value =
            enforceSingleHeart(
              value
            );

          /*
           * Maximum total is defined by placement or product.
           */

          value =
            limitText(
              value,
              getMaxCharacters()
            );

          if (
            textInput.value !==
            value
          ) {
            textInput.value =
              value;
          }

          updateState();
        }
      );
    }

    /*
 * Pillow pair text inputs.
 */
textInputLeft?.addEventListener(
  'input',
  () => {
    let value =
      textInputLeft.value;

    value =
      enforceSingleHeart(value);

    value =
      limitText(
        value,
        getMaxCharacters()
      );

    if (
      textInputLeft.value !== value
    ) {
      textInputLeft.value = value;
    }

    updatePillowTextCounter(
      textInputLeft,
      characterCountLeft
    );
    updateState();
  }
);

textInputRight?.addEventListener(
  'input',
  () => {
    let value =
      textInputRight.value;

    value =
      enforceSingleHeart(value);

    value =
      limitText(
        value,
        getMaxCharacters()
      );

    if (
      textInputRight.value !== value
    ) {
      textInputRight.value = value;
    }

    updatePillowTextCounter(
      textInputRight,
      characterCountRight
    );
    updateState();
  }
);

textInputTowel1?.addEventListener(
  'input',
  () => {
    let value =
      textInputTowel1.value;

    value =
      enforceSingleHeart(value);

    value =
      limitText(
        value,
        getMaxCharacters()
      );

    if (
      textInputTowel1.value !== value
    ) {
      textInputTowel1.value = value;
    }

    updatePillowTextCounter(
      textInputTowel1,
      characterCountTowel1
    );

    updateState();
  }
);

textInputTowel2?.addEventListener(
  'input',
  () => {
    let value =
      textInputTowel2.value;

    value =
      enforceSingleHeart(value);

    value =
      limitText(
        value,
        getMaxCharacters()
      );

    if (
      textInputTowel2.value !== value
    ) {
      textInputTowel2.value = value;
    }

    updatePillowTextCounter(
      textInputTowel2,
      characterCountTowel2
    );

    updateState();
  }
);

textInputTowel3?.addEventListener(
  'input',
  () => {
    let value =
      textInputTowel3.value;

    value =
      enforceSingleHeart(value);

    value =
      limitText(
        value,
        getMaxCharacters()
      );

    if (
      textInputTowel3.value !== value
    ) {
      textInputTowel3.value = value;
    }

    updatePillowTextCounter(
      textInputTowel3,
      characterCountTowel3
    );

    updateState();
  }
);

textInputTowel4?.addEventListener(
  'input',
  () => {
    let value =
      textInputTowel4.value;

    value =
      enforceSingleHeart(value);

    value =
      limitText(
        value,
        getMaxCharacters()
      );

    if (
      textInputTowel4.value !== value
    ) {
      textInputTowel4.value = value;
    }

    updatePillowTextCounter(
      textInputTowel4,
      characterCountTowel4
    );

    updateState();
  }
);

textInputTwoTowels1?.addEventListener(
  'input',
  () => {
    let value =
      textInputTwoTowels1.value;

    value =
      enforceSingleHeart(value);

    value =
      limitText(
        value,
        getMaxCharacters()
      );

    if (
      textInputTwoTowels1.value !== value
    ) {
      textInputTwoTowels1.value = value;
    }

    updatePillowTextCounter(
      textInputTwoTowels1,
      characterCountTwoTowels1
    );

    updateState();
  }
);

textInputTwoTowels2?.addEventListener(
  'input',
  () => {
    let value =
      textInputTwoTowels2.value;

    value =
      enforceSingleHeart(value);

    value =
      limitText(
        value,
        getMaxCharacters()
      );

    if (
      textInputTwoTowels2.value !== value
    ) {
      textInputTwoTowels2.value = value;
    }

    updatePillowTextCounter(
      textInputTwoTowels2,
      characterCountTwoTowels2
    );

    updateState();
  }
);

    /*
     * =====================================================
     * HEART BUTTON
     * =====================================================
     */

    if (
      heartButton &&
      textInput
    ) {
      heartButton.addEventListener(
        'click',
        () => {
          if (
            containsHeart(
              textInput.value
            )
          ) {
            return;
          }

          if (
            characterLength(
              textInput.value
            ) >= getMaxCharacters()
          ) {
            return;
          }

          const current =
            textInput.value;

          const start =
            textInput.selectionStart ??
            current.length;

          const end =
            textInput.selectionEnd ??
            current.length;

          const next =
            current.slice(
              0,
              start
            ) +
            '❤️' +
            current.slice(
              end
            );

          textInput.value =
            limitText(
              enforceSingleHeart(
                next
              ),
              getMaxCharacters()
            );

          textInput.focus();

          try {
            const cursorPosition =
              start + '❤️'.length;

            textInput.setSelectionRange(
              cursorPosition,
              cursorPosition
            );
          } catch (error) {
            // No action required.
          }

          updateState();
        }
      );
    }

    function insertPillowHeart(
  input,
  counter
) {
  if (!input) {
    return;
  }

  /*
   * Maximum ONE heart per pillowcase.
   */
  if (containsHeart(input.value)) {
    return;
  }

  if (
    characterLength(input.value) >=
    getMaxCharacters()
  ) {
    return;
  }

  const current = input.value;

  const start =
    input.selectionStart ??
    current.length;

  const end =
    input.selectionEnd ??
    current.length;

  const next =
    current.slice(0, start) +
    '❤️' +
    current.slice(end);

  input.value =
    limitText(
      enforceSingleHeart(next),
      getMaxCharacters()
    );

  input.focus();

  try {
    const cursorPosition =
      start + '❤️'.length;

    input.setSelectionRange(
      cursorPosition,
      cursorPosition
    );
  } catch (error) {
    // No action required.
  }

  updatePillowTextCounter(
    input,
    counter
  );
  updateState();
}

heartButtonLeft?.addEventListener(
  'click',
  () => {
    insertPillowHeart(
      textInputLeft,
      characterCountLeft
    );
  }
);

heartButtonRight?.addEventListener(
  'click',
  () => {
    insertPillowHeart(
      textInputRight,
      characterCountRight
    );
  }
);

heartButtonTowel1?.addEventListener(
  'click',
  () => {
    insertPillowHeart(
      textInputTowel1,
      characterCountTowel1
    );
  }
);

heartButtonTowel2?.addEventListener(
  'click',
  () => {
    insertPillowHeart(
      textInputTowel2,
      characterCountTowel2
    );
  }
);

heartButtonTowel3?.addEventListener(
  'click',
  () => {
    insertPillowHeart(
      textInputTowel3,
      characterCountTowel3
    );
  }
);

heartButtonTowel4?.addEventListener(
  'click',
  () => {
    insertPillowHeart(
      textInputTowel4,
      characterCountTowel4
    );
  }
);

heartButtonTwoTowels1?.addEventListener(
  'click',
  () => {
    insertPillowHeart(
      textInputTwoTowels1,
      characterCountTwoTowels1
    );
  }
);

heartButtonTwoTowels2?.addEventListener(
  'click',
  () => {
    insertPillowHeart(
      textInputTwoTowels2,
      characterCountTwoTowels2
    );
  }
);

    /*
     * =====================================================
     * GALLERY
     * =====================================================
     */

    let galleryIndex = 0;

    const galleryItems = Array.from(
      overlay.querySelectorAll(
        '[data-gallery-item]'
      )
    );

    function renderGallery() {
      galleryItems.forEach(
        (item, index) => {
          item.hidden =
            index !== galleryIndex;
        }
      );
    }

    const galleryNext =
      overlay.querySelector(
        '[data-gallery-next]'
      );

    const galleryPrev =
      overlay.querySelector(
        '[data-gallery-prev]'
      );

    if (galleryNext) {
      galleryNext.addEventListener(
        'click',
        () => {
          if (!galleryItems.length) {
            return;
          }

          galleryIndex =
            (
              galleryIndex + 1
            ) %
            galleryItems.length;

          renderGallery();
        }
      );
    }

    if (galleryPrev) {
      galleryPrev.addEventListener(
        'click',
        () => {
          if (!galleryItems.length) {
            return;
          }

          galleryIndex =
            (
              galleryIndex -
              1 +
              galleryItems.length
            ) %
            galleryItems.length;

          renderGallery();
        }
      );
    }

    /*
     * =====================================================
     * ERRORS
     * =====================================================
     */

    function showError(message) {
      if (!errorElement) {
        return;
      }

      errorElement.textContent =
        message;

      errorElement.hidden =
        false;
    }

    function clearError() {
      if (!errorElement) {
        return;
      }

      errorElement.textContent =
        '';

      errorElement.hidden =
        true;
    }

    /*
     * =====================================================
     * ATELIER CART SECTIONS
     * =====================================================
     */

    function getCartSectionIds() {
      const components =
        document.querySelectorAll(
          'cart-items-component'
        );

      const sectionIds = [];

      components.forEach(
        component => {
          if (
            component instanceof HTMLElement &&
            component.dataset.sectionId
          ) {
            sectionIds.push(
              component.dataset.sectionId
            );
          }
        }
      );

      return [
        ...new Set(sectionIds)
      ];
    }

    function renderProductSummary() {
  const packElement =
    document.querySelector(
      'pack-product'
    );

  if (
    packElement &&
    typeof packElement.getSelectedPackPrice ===
      'function'
  ) {
    const packPrice =
      packElement.getSelectedPackPrice();

    if (packPrice !== null) {
      if (summaryProductPrice) {
        summaryProductPrice.textContent =
          formatMoney(packPrice);
      }

      if (summaryTotal) {
        summaryTotal.textContent =
          formatMoney(
            packPrice +
            (state.embroideryPrice || 0)
          );
      }

      return;
    }
  }

  const variant =
    getSelectedProductVariant();

  if (!variant) {
    if (summaryProductPrice) {
      summaryProductPrice.textContent = '—';
    }

    if (summaryTotal) {
      summaryTotal.textContent = '—';
    }

    return;
  }

  const productPrice =
    Number(variant.price || 0);

  const productTotal =
    productPrice * state.quantity;

  /*
   * Selected variant / size.
   */
  if (summaryProductVariant) {
    const base =
      summaryProductVariant.dataset.baseTitle ||
      summaryProductVariant.textContent.trim();

    if (!summaryProductVariant.dataset.baseTitle) {
      summaryProductVariant.dataset.baseTitle =
        base;
    }

    const variantTitle =
  variant.public_title ||
  variant.title ||
  '';

summaryProductVariant.textContent =
  variantTitle &&
  variantTitle !== base
    ? `${base} · ${variantTitle}`
    : base;
  }

  /*
   * Product price.
   */
  if (summaryProductPrice) {
    summaryProductPrice.textContent =
      formatMoney(productTotal);
  }

  /*
   * Embroidery total.
   */
  let embroideryTotal = 0;

  if (
    state.quantity > 1 &&
    state.multipleMode === 'different'
  ) {
    embroideryTotal =
      embroideryJobs.reduce(
        (sum, job) =>
          sum +
          Number(
            job.embroideryPrice || 0
          ),
        0
      );
  } else {
    embroideryTotal =
      Number(
        state.embroideryPrice || 0
      ) * state.quantity;
  }

  /*
   * Grand total.
   */
  if (summaryTotal) {
    summaryTotal.textContent =
      formatMoney(
        productTotal +
        embroideryTotal
      );
  }
}

    function renderSummaryPrice() {
  if (!summaryPrice) {
    return;
  }

  if (
    state.quantity > 1 &&
    state.multipleMode === 'different'
  ) {
    const total =
      embroideryJobs.reduce(
        (sum, job) =>
          sum +
          Number(job.embroideryPrice || 0),
        0
      );

    summaryPrice.textContent =
      total > 0
        ? formatMoney(total)
        : '—';

    return;
  }

  const hasEmbroideryPrice =
(
  config.isPillowPair ||
  config.isHandTowelPair ||
  config.isTowelQuad ||
  config.isTwoTowels
)
  ? state.embroideryPrice > 0
  : !!state.embroideryVariantId;

summaryPrice.textContent =
  hasEmbroideryPrice
    ? formatMoney(
        state.embroideryPrice *
        state.quantity
      )
    : '—';
}


/*
 * =====================================================
 * QUANTITY
 * =====================================================
 */



function renderQuantity() {
  if (quantityElement) {
    quantityElement.textContent =
      String(state.quantity);
  }

  if (quantityMinus) {
    quantityMinus.disabled =
      state.quantity <= 1;
  }

  if (multipleEmbroidery) {
    multipleEmbroidery.hidden =
      state.quantity <= 1;
  }

  renderSummaryPrice();
  renderProductSummary();
}

if (quantityMinus) {
  quantityMinus.addEventListener(
    'click',
    () => {
      if (state.quantity <= 1) {
        return;
      }

      state.quantity -= 1;
      syncEmbroideryJobs();
      renderQuantity();
    }
  );
}

if (quantityPlus) {
  quantityPlus.addEventListener(
    'click',
    () => {
      state.quantity += 1;
      syncEmbroideryJobs();
      renderQuantity();
    }
  );
}

multipleModeInputs.forEach(input => {
  input.addEventListener(
    'change',
    () => {
      /*
       * Radio version:
       * ignore unchecked radios.
       *
       * Select version:
       * use the selected value directly.
       */
      if (
        input.type === 'radio' &&
        !input.checked
      ) {
        return;
      }

      state.multipleMode =
        input.value;

      syncEmbroideryJobs();

      renderQuantity();

      updateState();
    }
  );
});


/*
 * =====================================================
 * ADD TO CART
 * =====================================================
 */

    submitButton.addEventListener(
      'click',
      async () => {
        updateState();

        clearError();

        if (submitButton.disabled) {
          return;
        }

        /*
         * Resolve selected real product variant.
         */

        const productVariantId =
  getSelectedProductVariantId();

if (
  !config.isTwoTowels &&
  !productVariantId
) {
  showError(selectSizeLabel);

  return;
}

  if (
  !config.isPillowPair &&
  !config.isHandTowelPair &&
  !config.isTowelQuad &&
  !config.isTwoTowels &&
  !state.embroideryVariantId
) {
  showError(
    'Impossible de déterminer le tarif de la broderie.'
  );

  return;
}

        /*
 * =================================================
 * CART LINES
 * =================================================
 *
 * SAME:
 * One product line + one embroidery line,
 * both using the requested quantity.
 *
 * DIFFERENT:
 * One product line + one embroidery line
 * for each individual configuration.
 */

const items = [];


/*
 * =================================================
 * BUILD EMBROIDERY PAIR
 * =================================================
 */

function getSelectedPackItems() {
  const combinationHandle =
    decodeURIComponent(
      window.location.hash.replace(/^#/, '')
    );

  if (!combinationHandle) {
    return [];
  }

  const combination =
    document.querySelector(
      `.pack-product__combination[data-combination="${CSS.escape(combinationHandle)}"]`
    );

  if (!combination) {
    return [];
  }

  const selectors = Array.from(
    combination.querySelectorAll(
      '.pack-product__variant'
    )
  ).filter(select => select.value);

  let twoTowelsIndex = 0;

  return selectors.map(select => {
    const productId =
      String(
        select.dataset.productId || ''
      );

    let isTwoTowelsEmbroideryTarget = false;
    let twoTowelsEmbroideryIndex = null;

    if (
      config.isTwoTowels &&
      twoTowelsIndex < 2
    ) {
      twoTowelsIndex += 1;

      isTwoTowelsEmbroideryTarget = true;
      twoTowelsEmbroideryIndex =
        twoTowelsIndex;
    }

    return {
      id: Number(select.value),

      productId,

      isEmbroideryTarget:
        select.hasAttribute(
          'data-pack-embroidery-target'
        ),

      isTwoTowelsEmbroideryTarget,

      twoTowelsEmbroideryIndex
    };
  });
}

function addEmbroideryPair(
  job,
  quantity = 1
) {
  const embroideryId =
    createEmbroideryId();

  /*
   * =================================================
   * MAIN PRODUCT PROPERTIES
   * =================================================
   */

  const productProperties = {
    '_embroidery_id':
      embroideryId,

    'Couleur de fil':
      job.colour
  };


  /*
  * Standard embroidery has one service variant.
  *
  * Taies and Paires can have two, so we deliberately
  * do not expose a single _embroidery_variant_id.
  */

  if (
  !config.isPillowPair &&
  !config.isHandTowelPair &&
  !config.isTowelQuad &&
  !config.isTwoTowels &&
  job.embroideryVariantId
) {
    productProperties[
      '_embroidery_variant_id'
    ] = String(
      job.embroideryVariantId
    );
  }

  if (job.spool) {
    productProperties[
      '_spool'
    ] = job.spool;
    productProperties[
      'Bobine'
    ] = job.spool;
  }

  if (job.placement) {
    productProperties[
      'Emplacement'
    ] = job.placement;
  }

  /*
   * =================================================
   * TEXT
   * =================================================
   */

  if (job.mode === 'text') {
    productProperties[
      'Type de broderie'
    ] = 'Texte';

    /*
     * Pillow pair.
     */
    if (config.isPillowPair || config.isHandTowelPair) {
      if (job.textLeft) {
        productProperties[
          config.isHandTowelPair ? 'Serviette 1' : 'Taie gauche'
        ] = job.textLeft;
      }

      if (job.textRight) {
        productProperties[
          config.isHandTowelPair ? 'Serviette 2' : 'Taie droite'
        ] = job.textRight;
      }
    }

    else if (config.isTowelQuad) {
  if (job.textTowel1) {
    productProperties[
      'Carré 1'
    ] = job.textTowel1;
  }

  if (job.textTowel2) {
    productProperties[
      'Carré 2'
    ] = job.textTowel2;
  }

  if (job.textTowel3) {
    productProperties[
      'Carré 3'
    ] = job.textTowel3;
  }

  if (job.textTowel4) {
    productProperties[
      'Carré 4'
    ] = job.textTowel4;
  }
}

    /*
     * Standard text.
     */
    else {
      productProperties[
        'Texte à broder'
      ] = job.text;
    }

    productProperties[
      'Typographie'
    ] = job.font;
  }

  /*
   * =================================================
   * SYMBOL
   * =================================================
   */

  if (job.mode === 'symbol') {
    productProperties[
      'Type de broderie'
    ] = 'Symbole';

    productProperties[
      'Symbole'
    ] = job.symbol;
  }

  /*
   * =================================================
   * MAIN PRODUCT
   * =================================================
   */

  const packItems =
  getSelectedPackItems();

if (packItems.length) {

  const packId =
    typeof crypto !== 'undefined' &&
    crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random()
          .toString(36)
          .slice(2)}`;

  const packElement =
    document.querySelector('pack-product');

  const packName =
    packElement?.dataset.packName || '';

  const packUrl =
    packElement?.dataset.productUrl || '';

  const packImage =
  typeof packElement?.getSelectedPackImage === 'function'
    ? packElement.getSelectedPackImage()
    : packElement?.dataset.productImage || '';

  const activeButton =
    packElement?.querySelector(
      '.pack-product__colour.is-active'
    );

  const combinationName =
    activeButton?.dataset.combinationName ||
    activeButton?.textContent.trim() ||
    '';

  packItems.forEach(packItem => {

    const packProperties = {
      _PackID: packId,
      _Pack: packName,
      _PackURL: packUrl,
      _PackImage: packImage,
      _Combinaison: combinationName
    };

    /*
 * Existing Parure / Taies behaviour.
 */
if (packItem.isEmbroideryTarget) {
  Object.assign(
    packProperties,
    productProperties
  );
}

/*
 * 2-serviettes:
 * associate each configured embroidery
 * with its corresponding physical component.
 */
if (
  config.isTwoTowels &&
  packItem.isTwoTowelsEmbroideryTarget
) {
  const twoTowelsTargets =
    packItems.filter(
      item =>
        item.isTwoTowelsEmbroideryTarget
    );

  const targetIndex =
    twoTowelsTargets.indexOf(packItem);

  const text =
    targetIndex === 0
      ? job.textTwoTowels1
      : targetIndex === 1
        ? job.textTwoTowels2
        : '';

  const variantId =
    targetIndex === 0
      ? job.twoTowels1VariantId
      : targetIndex === 1
        ? job.twoTowels2VariantId
        : null;

  if (text && variantId) {
    Object.assign(
      packProperties,
      {
        '_embroidery_id':
          embroideryId,

        '_embroidery_variant_id':
          String(variantId),

        'Couleur de fil':
          job.colour,

        'Emplacement':
          job.placement,

        'Type de broderie':
          'Texte',

        'Texte à broder':
          text,

        'Typographie':
          job.font
      }
    );

    if (job.spool) {

      packProperties['_spool'] =
        job.spool;

      packProperties['Bobine'] =
        job.spool;

    }
  }
}

    items.push({
      id: packItem.id,
      quantity,
      properties: packProperties
    });
  });

} else {

  /*
   * Existing behaviour for
   * normal non-pack products.
   */
  items.push({
    id:
      productVariantId,

    quantity,

    properties:
      productProperties
  });
}

  /*
   * =================================================
   * PILLOW PAIR EMBROIDERY SERVICES
   * =================================================
   */

  if (
    (config.isPillowPair || config.isHandTowelPair) &&
    job.mode === 'text'
  ) {
    /*
     * Left pillow.
     */
    if (
      job.textLeft &&
      job.pillowLeftVariantId
    ) {
      items.push({
        id:
          job.pillowLeftVariantId,

        quantity,

        properties: {
          '_embroidery_id':
            embroideryId,

          '_embroidery_for':
            String(
              productVariantId
            ),

          '_embroidery_service':
            'true',

          '_embroidery_side':
            config.isHandTowelPair ? 'towel-1' : 'left'
        }
      });
    }

    /*
     * Right pillow.
     */
    if (
      job.textRight &&
      job.pillowRightVariantId
    ) {
      items.push({
        id:
          job.pillowRightVariantId,

        quantity,

        properties: {
          '_embroidery_id':
            embroideryId,

          '_embroidery_for':
            String(
              productVariantId
            ),

          '_embroidery_service':
            'true',

          '_embroidery_side':
            config.isHandTowelPair ? 'towel-2' : 'right'
        }
      });
    }

    return;
  }

    /*
   * =================================================
   * TOWEL QUAD EMBROIDERY SERVICES
   * =================================================
   */

  if (
    config.isTowelQuad &&
    job.mode === 'text'
  ) {
    if (
      job.textTowel1 &&
      job.towel1VariantId
    ) {
      items.push({
        id: job.towel1VariantId,
        quantity,
        properties: {
          '_embroidery_id':
            embroideryId,

          '_embroidery_for':
            String(
              productVariantId
            ),

          '_embroidery_service':
            'true',

          '_embroidery_side':
            'towel-1'
        }
      });
    }

    if (
      job.textTowel2 &&
      job.towel2VariantId
    ) {
      items.push({
        id: job.towel2VariantId,
        quantity,
        properties: {
          '_embroidery_id':
            embroideryId,

          '_embroidery_for':
            String(
              productVariantId
            ),

          '_embroidery_service':
            'true',

          '_embroidery_side':
            'towel-2'
        }
      });
    }

    if (
      job.textTowel3 &&
      job.towel3VariantId
    ) {
      items.push({
        id: job.towel3VariantId,
        quantity,
        properties: {
          '_embroidery_id':
            embroideryId,

          '_embroidery_for':
            String(
              productVariantId
            ),

          '_embroidery_service':
            'true',

          '_embroidery_side':
            'towel-3'
        }
      });
    }

    if (
      job.textTowel4 &&
      job.towel4VariantId
    ) {
      items.push({
        id: job.towel4VariantId,
        quantity,
        properties: {
          '_embroidery_id':
            embroideryId,

          '_embroidery_for':
            String(
              productVariantId
            ),

          '_embroidery_service':
            'true',

          '_embroidery_side':
            'towel-4'
        }
      });
    }

        return;
  }

  /*
   * =================================================
   * 2-SERVIETTES EMBROIDERY SERVICES
   * =================================================
   */

  if (
    config.isTwoTowels &&
    job.mode === 'text'
  ) {
    const twoTowelsTargets =
      packItems.filter(
        item =>
          item.isTwoTowelsEmbroideryTarget
      );

    /*
     * First embroiderable component.
     */
    if (
      job.textTwoTowels1 &&
      job.twoTowels1VariantId &&
      twoTowelsTargets[0]
    ) {
      items.push({
        id: job.twoTowels1VariantId,

        quantity,

        properties: {
          '_embroidery_id':
            embroideryId,

          '_embroidery_for':
            String(
              twoTowelsTargets[0].id
            ),

          '_embroidery_service':
            'true',

          '_embroidery_side':
            'towel-1'
        }
      });
    }

    /*
     * Second embroiderable component.
     */
    if (
      job.textTwoTowels2 &&
      job.twoTowels2VariantId &&
      twoTowelsTargets[1]
    ) {
      items.push({
        id: job.twoTowels2VariantId,

        quantity,

        properties: {
          '_embroidery_id':
            embroideryId,

          '_embroidery_for':
            String(
              twoTowelsTargets[1].id
            ),

          '_embroidery_service':
            'true',

          '_embroidery_side':
            'towel-2'
        }
      });
    }

    return;
  }

  /*
   * =================================================
   * STANDARD EMBROIDERY SERVICE
   * =================================================
   */

  const embroideryProperties = {
    '_embroidery_id':
      embroideryId,

    '_embroidery_for':
      String(
        productVariantId
      ),

    '_embroidery_service':
      'true'
  };

  items.push({
    id:
      job.embroideryVariantId,

    quantity,

    properties:
      embroideryProperties
  });
}


/*
 * =================================================
 * DIFFERENT EMBROIDERIES
 * =================================================
 */

if (
  state.quantity > 1 &&
  state.multipleMode === 'different'
) {
  embroideryJobs.forEach(
    job => {
      addEmbroideryPair(
        job,
        1
      );
    }
  );
}


/*
 * =================================================
 * SAME EMBROIDERY
 * =================================================
 */

else {
  addEmbroideryPair(
    createEmbroideryJob(),
    state.quantity
  );
}

        /*
         * =================================================
         * CART SECTIONS
         * =================================================
         */

        const sectionIds = [
  ...new Set([
    ...getCartSectionIds(),
    'cart-drawer-section'
  ])
];

const payload = {
  items,
  sections: sectionIds,
  sections_url: window.location.pathname
};



        /*
         * =================================================
         * LOADING
         * =================================================
         */

        state.loading = true;

        submitButton.disabled =
          true;

        submitButton.textContent =
          addingToCartLabel;

        try {
          /*
           * =================================================
           * ADD PRODUCT + EMBROIDERY
           * =================================================
           */

          const response =
            await fetch(
              '/cart/add.js',
              {
                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json'
                },

                body:
                  JSON.stringify(
                    payload
                  )
              }
            );

          const result =
            await response.json();

          if (
            !response.ok ||
            result.status
          ) {
            throw new Error(
              result.description ||
              result.message ||
              'Impossible d’ajouter la broderie au panier.'
            );
          }

          Shopify.analytics.publish(
  'embroidery_created',
  {
    embroidery_type: state.mode,
    embroidery_colour: state.colour,
    embroidery_placement: state.placement,
    embroidery_price: state.embroideryPrice,
    currency: config.currency || 'EUR',
    quantity: state.quantity,
    product_id: root.dataset.productId,
    variant_id: productVariantId
  }
);

          /*
           * =================================================
           * GET UPDATED CART
           * =================================================
           */

          const cartResponse =
            await fetch(
              '/cart.js',
              {
                headers: {
                  'Accept':
                    'application/json'
                }
              }
            );

          if (!cartResponse.ok) {
            throw new Error(
              'Impossible de mettre à jour le panier.'
            );
          }

          const cart =
            await cartResponse.json();

          /*
           * =================================================
           * UPDATE ATELIER HEADER CART BUBBLE
           * =================================================
           */

          const cartIcon =
            document.querySelector(
              'cart-icon'
            );

          if (
            cartIcon &&
            typeof cartIcon.renderCartBubble ===
              'function'
          ) {
            await cartIcon.renderCartBubble(
              cart.item_count
            );
          }

          /*
           * =================================================
           * CLOSE EMBROIDERY MODAL
           * =================================================
           */

          closeModal();

const drawerHtml =
  result.sections?.[
    'cart-drawer-section'
  ];

const currentDrawerSection =
  document.querySelector(
    '#shopify-section-cart-drawer-section'
  );

if (
  drawerHtml &&
  currentDrawerSection
) {
  const parsed =
    new DOMParser().parseFromString(
      drawerHtml,
      'text/html'
    );

  const freshDrawer =
    parsed.querySelector(
      '#shopify-section-cart-drawer-section'
    );

  if (freshDrawer) {
    currentDrawerSection.replaceWith(
      freshDrawer
    );
  } else {
    currentDrawerSection.innerHTML =
      drawerHtml;
  }
} else {
  const cartItems =
    document.querySelector(
      'cart-items-component[data-section-id="cart-drawer-section"]'
    );

  if (cartItems) {
    const { sectionRenderer } =
      await import('@theme/section-renderer');

    await sectionRenderer.renderSection(
      'cart-drawer-section',
      {
        cache: false,
        mode: 'hydration'
      }
    );
  }
}


          /*
           * =================================================
           * THEME CART UPDATE EVENT
           * =================================================
           */

          document.dispatchEvent(
            new CustomEvent(
              'cart:update',
              {
                bubbles: true,

                detail: {
                  resource:
                    cart,

                  sourceId:
                    `embroidery-${blockId}`,

                  data: {
                    source:
                      'embroidery',

                    itemCount:
                        cart.item_count,

                    productId:
                      root.dataset.productId,

                    variantId:
                      String(
                        productVariantId
                      ),

                    sections:
                      result.sections ||
                      {}
                  }
                }
              }
            )
          );

          /*
           * =================================================
           * OPEN ATELIER CART DRAWER
           * =================================================
           */

          const cartDrawer =
  document.querySelector(
    '#cart-drawer'
  );

if (
  cartDrawer &&
  typeof cartDrawer.open ===
    'function'
) {
  cartDrawer.open();
}



        } catch (error) {
          console.error(
            'Embroidery add-to-cart error:',
            error
          );

          showError(
            error.message ||
            'Une erreur est survenue.'
          );

        } finally {
          state.loading =
            false;

          submitButton.textContent =
            'Ajouter au panier';

          validate();
        }
      }
    );

    /*
     * =====================================================
     * INITIALISE
     * =====================================================
     */

    /*
 * Preselect colour when only one option exists.
 */
if (
  colourSelect &&
  colourOptions.length > 0
) {
  const option = colourOptions[0];

  const value =
    option.dataset.value || '';

  const hex =
    option.dataset.hex || '';

  const spool =
    option.dataset.spool || '';

  colourSelect.value = value;
  colourSelect.dataset.hex = hex;
  colourSelect.dataset.spool = spool;

  if (colourDropdownValue) {
    colourDropdownValue.textContent = value;
  }

  if (colourPreview) {
    colourPreview.style.backgroundColor = hex;
  }

  option.classList.add(
    'embroidery-colour-dropdown__option--selected'
  );

  const check = option.querySelector(
    '.embroidery-colour-dropdown__check'
  );

  if (check) {
    check.textContent = '✓';
  }
}

    initialiseMode();

    renderQuantity();

    updateState();
  }

  /*
   * =======================================================
   * INITIALISE ALL EMBROIDERY BLOCKS
   * =======================================================
   */

  function initAllEmbroidery() {
    document
      .querySelectorAll(
        '[data-embroidery-block]'
      )
      .forEach(
        initEmbroidery
      );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAllEmbroidery
    );
  } else {
    initAllEmbroidery();
  }

  /*
   * =======================================================
   * SHOPIFY THEME EDITOR
   * =======================================================
   */

  document.addEventListener(
    'shopify:section:load',
    event => {
      event.target
        .querySelectorAll(
          '[data-embroidery-block]'
        )
        .forEach(
          initEmbroidery
        );
    }
  );

  /*
   * =======================================================
   * ESCAPE
   * =======================================================
   */

  document.addEventListener(
    'keydown',
    event => {
      if (
        event.key !== 'Escape'
      ) {
        return;
      }

      const openOverlays =
        document.querySelectorAll(
          '.embroidery-modal-overlay:not([hidden])'
        );

      openOverlays.forEach(
        overlay => {
          overlay.hidden = true;
        }
      );

      if (
        openOverlays.length
      ) {
        document.body.classList.remove(
          'embroidery-modal-open'
        );
      }
    }
  );
})();
